import { Link } from "react-router-dom"

import { TAB_NAMES, TAB_PATHS } from "../constants"
import { TABS } from "../interfaces"
import { Community } from "../Community"
import { Service } from "../Service"

import style from "./style.module.scss"

import { MobileNavigation } from "components/Header"
import { PsyAvatar } from "modules/PsychologistAccount/PsyAvatar"
import { createPath } from "modules/PsychologistAccount/helpers"
import { PsyAccountDetails } from "modules/PsychologistAccount/common/queries"

interface Props {
    key: string
    accountDetails: PsyAccountDetails
    isClientsFeedbackEnabled: boolean
    getPath: (path: string) => string
}

export function MobileMenu({ key, accountDetails, isClientsFeedbackEnabled, getPath }: Props) {
    return (
        <MobileNavigation.Menu key={key} title="alter" highlight>
            <MobileNavigation.Highlight>
                <div>
                    <MobileNavigation.Line />
                    <MobileNavigation.Item className={style.profileLink}>
                        <PsyAvatar
                            name={accountDetails.profile.display_name}
                            isAdaptive
                            className={style.profileLinkAvatar}
                        />
                        <Link to={createPath("/settings")}>Профиль</Link>
                    </MobileNavigation.Item>
                </div>
                {Object.keys(TAB_NAMES).map((tabKey) => {
                    const tab = tabKey as TABS
                    if (tab === TABS.CLIENTS_FEEDBACK && !isClientsFeedbackEnabled) return null

                    return (
                        <div key={tab}>
                            <MobileNavigation.Line />
                            <MobileNavigation.Item>
                                <Link to={getPath(TAB_PATHS[tab])}>{TAB_NAMES[tab]}</Link>
                            </MobileNavigation.Item>
                        </div>
                    )
                })}
            </MobileNavigation.Highlight>
            <MobileNavigation.Item>
                <Community />
            </MobileNavigation.Item>
            <MobileNavigation.Line />
            <MobileNavigation.Item>
                <Service />
            </MobileNavigation.Item>
        </MobileNavigation.Menu>
    )
}
